var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowerBlueSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00317383 73.998C20.4377 73.998 37.0032 57.4326 37.0032 36.998H0.00317383V73.998Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0032 37C37.0032 16.5655 53.5686 7.24099e-07 74.0032 1.61732e-06L74.0032 37L37.0032 37Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 37.001C16.5655 37.001 2.8964e-06 20.4355 6.46929e-06 0.000976562L37 0.000983032L37 37.001Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9932 74.001C73.9932 53.5664 57.4277 37.001 36.9932 37.001L36.9932 74.001L73.9932 74.001Z",
    fill: "#3498DB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerBlueSquare);
export default __webpack_public_path__ + "static/media/flower-blue-square.91b67a5a77c4a8a962d4630aa7f073ed.svg";
export { ForwardRef as ReactComponent };